import React, { useEffect, useState } from 'react'
import './LandingNavbar.css'
import Config from '../../Config.json'
// The bar carries the brand deep so the logo and wordmark are white.
import Logo from './assets/HMYLogoWhiteTransparent.png'

import { LuMenu, LuX } from 'react-icons/lu'
import { Link } from 'react-router'

// Sections that belong under a nav item without having an item of their own.
const SECTION_TO_NAV = {
    hero: 'hero',
    about: 'about',
    services: 'services',
    programs: 'services',
    groups: 'services',
    pricing: 'pricing',
    contact: 'contact'
};

export default function Navbar ({ items }) {

    const [isNavbarMobileOpen, setIsNavbarMobileOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('hero');
    const [isScrolled, setIsScrolled] = useState(false);

    // The active item is whichever section crosses a line near the middle of the viewport.
    useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') return undefined;

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActiveSection(SECTION_TO_NAV[entry.target.id]);
                    }
                });
            },
            { rootMargin: '-45% 0px -54% 0px' }
        );

        Object.keys(SECTION_TO_NAV).forEach(id => {
            const element = document.getElementById(id);
            if (element) observer.observe(element);
        });

        return () => observer.disconnect();
    }, []);

    // The bar gains a shadow once the hero is no longer fully in view.
    useEffect(() => {
        const hero = document.getElementById('hero');
        if (!hero || typeof IntersectionObserver === 'undefined') return undefined;

        const observer = new IntersectionObserver(
            ([entry]) => setIsScrolled(entry.intersectionRatio < 0.98),
            { threshold: [0, 0.98, 1] }
        );
        observer.observe(hero);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!isNavbarMobileOpen) return undefined;
        const onKeyDown = event => event.key === 'Escape' && setIsNavbarMobileOpen(false);
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isNavbarMobileOpen]);

    const closeMenu = () => setIsNavbarMobileOpen(false);

    const createItem = item => {
        const isActive = !item.Redirect && activeSection === item.Name;
        const className = [
            'lp-nav-link',
            isActive ? 'active' : '',
            item.Name === 'login' ? 'lp-nav-login' : ''
        ].join(' ').trim();

        return (
            <li key={item.Name}>
                {item.Redirect ? (
                    <Link className={className} to={`/${item.Name}`} onClick={closeMenu}>{item.Alias}</Link>
                ) : (
                    <a className={className} href={`#${item.Name}`} onClick={closeMenu} aria-current={isActive ? 'true' : undefined}>{item.Alias}</a>
                )}
            </li>
        );
    };

    return (
        <header className={`lp-nav ${isScrolled ? 'is-scrolled' : ''}`}>
            <div className="lp-nav-row">
                <Link to="/" className="lp-nav-logo" onClick={closeMenu}>
                    <img src={Logo} alt="" />
                    <span>{Config.Appname}</span>
                </Link>

                <button
                    type="button"
                    className="lp-nav-toggle"
                    aria-label={isNavbarMobileOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={isNavbarMobileOpen}
                    aria-controls="lp-nav-menu"
                    onClick={() => setIsNavbarMobileOpen(open => !open)}
                >
                    {isNavbarMobileOpen ? <LuX /> : <LuMenu />}
                </button>

                <nav id="lp-nav-menu" className={`lp-nav-menu ${isNavbarMobileOpen ? 'is-open' : ''}`} aria-label="Main">
                    <ul>
                        {items.map(createItem)}
                    </ul>
                </nav>
            </div>
        </header>
    )
}
